import * as React from 'react';
import {
  ImageStyle,
  Pressable,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';
import dateformat from 'dateformat';

import FastImageAdapter from '../../../shared/fast_image/FastImageAdapter';
import DimensionContext from '../../../shared/dimension/DimensionContext';
import PrimaryButton from '../../../shared/buttons/PrimaryButton';
import MultiSwitch from '../../../shared/forms/MultiSwitch';
import LabelWithOption from '../../../shared/forms/LabelWithOption';

import StoryCoverImageDecorator from '../../../../view_models/StoryCoverImageDecorator';

import {colors, formStyles} from '../../../../styles/variables';
import {storyCoverImageUrl} from '../../../../helpers/images';

import Story from '../../../../../domain/entities/writer/vertical_short_video/Story';

interface Props {
  story: Story;
  isGradeBlack: boolean;
  watermarked: boolean;
  onChangeWatermarked: (watermarked: boolean) => void;
  onEpisodeVideoExport: () => void;
}

const WATERMARK_ITEMS = [
  {label: '有り', value: 'present'},
  {label: '無し', value: 'blank'},
];

const Detail: React.FunctionComponent<Props> = props => {
  const {
    story,
    isGradeBlack,
    watermarked,
    onChangeWatermarked,
    onEpisodeVideoExport,
  } = props;
  const source = React.useMemo(() => {
    return {
      uri: storyCoverImageUrl(new StoryCoverImageDecorator(story), 'large'),
      headers: {Accept: 'image/webp,image/apng,*/*'},
    };
  }, []);
  const handleChangeWatermark = React.useCallback(
    (item: {label: string; value: string}) => {
      onChangeWatermarked(item.value === 'present');
    },
    [onChangeWatermarked],
  );
  return (
    <DimensionContext.Consumer>
      {context => {
        const width = context.content.width * 0.48;
        const size = {width, height: width / ASPECT_RATIO};
        return (
          <View style={styles.container}>
            <View style={styles.imageWrapper}>
              {story.hasCoverImage ? (
                <FastImageAdapter
                  style={[styles.image, size]}
                  source={source}
                />
              ) : (
                <View style={[styles.image, size]}>
                  <Text style={styles.noImageText}>表紙なし</Text>
                </View>
              )}
            </View>
            {isGradeBlack ? (
              <View style={[formStyles.formGroup, styles.watermarkGroup]}>
                <LabelWithOption title={'ロゴ'} />
                <MultiSwitch
                  items={WATERMARK_ITEMS}
                  value={watermarked ? 'present' : 'blank'}
                  onSelectItem={handleChangeWatermark}
                />
              </View>
            ) : null}
            <PrimaryButton
              disabled={['job_running', 'up-to-date'].includes(story.status)}
              onPress={onEpisodeVideoExport}>
              このストーリーのCM動画を作成する
            </PrimaryButton>
          </View>
        );
      }}
    </DimensionContext.Consumer>
  );
};

export default React.memo(Detail);

const ASPECT_RATIO = 0.7;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  } as ViewStyle,
  watermarkGroup: {
    width: '100%',
    paddingHorizontal: 16,
  } as ViewStyle,
  imageWrapper: {
    marginTop: 32,
    alignItems: 'center',
    marginBottom: 32,
  } as ViewStyle,
  image: {
    alignItems: 'center',
    aspectRatio: ASPECT_RATIO,
    backgroundColor: colors.powderGray,
    justifyContent: 'center',
  } as ImageStyle,
  noImageText: {
    color: colors.lightGray,
    fontSize: 10,
  } as TextStyle,
});
